/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr erfahren`
};

const en_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `More information`
};

const es_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `Más información`
};

const fr_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `En savoir plus`
};

const it_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri di più`
};

const nl_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `Meer informatie`
};

const pt_launchpad__account_modal_more = /** @type {(inputs: {}) => string} */ () => {
	return `Saiba mais`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_more(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_more", locale)
	if (locale === "de") return de_launchpad__account_modal_more(inputs)
	if (locale === "en") return en_launchpad__account_modal_more(inputs)
	if (locale === "es") return es_launchpad__account_modal_more(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_more(inputs)
	if (locale === "it") return it_launchpad__account_modal_more(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_more(inputs)
	return pt_launchpad__account_modal_more(inputs)
};